export default __webpack_public_path__ + "static/media/emptyUsersView.9d4d350b.svg";